/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SecurityAuthenticationAliases {
  FETCH_SECURITY_AUTHENTICATION = 'fetch-security-authentication',
  FIELD_SECURITY_AUTHENTICATION_STATUS = 'field-security-authentication-status',
  FORM_SECURITY_AUTHENTICATION = 'form-security-authentication',
  LAYOUT_SECURITY_AUTHENTICATION = 'layout-security-authentication',
  LOADER_MFA_SWITCH = 'loader-mfa-switch',
  MAPPER_FETCH_SECURITY_AUTHENTICATION = 'mapper-fetch-security-authentication',
  PANEL_LOADER_MFA_SWITCH = 'panel-loader-mfa-switch',
  PANEL_SECURITY_AUTHENTICATION = 'panel-security-authentication',
  SWITCH_SECURITY_AUTHENTICATION = 'switch-security-authentication',
  TEXT_SWITCH_MFA = 'text-switch-mfa',
}
export { SecurityAuthenticationAliases };
